// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecordButton_record-btn__K78QW {
  position: relative;
  width: 10rem;
  height: 10rem;
  padding: 1rem;
  margin-inline: auto;
  border: 1px solid var(--primary-color);
  border-radius: 0.8rem;
  background-color: var(--gray-extra-light);
  display: flex;
  justify-content: center;
  align-items: center;
}

.RecordButton_record-btn--recording__irVBI,
.RecordButton_record-btn--error__5-ZdY {
  border-color: var(--danger);
}

.RecordButton_record-btn--recording__irVBI {
  background-color: var(--error-extra-light);
}

.RecordButton_record-btn--recording__irVBI::before {
  content: "";
  display: block;
  width: 1.7rem;
  height: 1.7rem;
  background-color: #fff;
  border-radius: 0.2rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`, "",{"version":3,"sources":["webpack://./src/components/VoiceOrder/VoiceOrderForm/RecordButton/RecordButton.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,qBAAqB;EACrB,yCAAyC;EACzC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC","sourcesContent":[".record-btn {\n  position: relative;\n  width: 10rem;\n  height: 10rem;\n  padding: 1rem;\n  margin-inline: auto;\n  border: 1px solid var(--primary-color);\n  border-radius: 0.8rem;\n  background-color: var(--gray-extra-light);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.record-btn--recording,\n.record-btn--error {\n  border-color: var(--danger);\n}\n\n.record-btn--recording {\n  background-color: var(--error-extra-light);\n}\n\n.record-btn--recording::before {\n  content: \"\";\n  display: block;\n  width: 1.7rem;\n  height: 1.7rem;\n  background-color: #fff;\n  border-radius: 0.2rem;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"record-btn": `RecordButton_record-btn__K78QW`,
	"record-btn--recording": `RecordButton_record-btn--recording__irVBI`,
	"record-btn--error": `RecordButton_record-btn--error__5-ZdY`
};
export default ___CSS_LOADER_EXPORT___;
